/** Appui long au doigt sur la carte (menu d'une unité, docs/14 §2.1 ; « Ajouter une annotation ici » sur un endroit
 *  vide, demande d'Alexis du 16/10/2026) : sans mouvement au-delà de 10 px pendant 500 ms, l'appui se déclenche.
 *  Pendant ce temps, le glissement d'un objet saisi ne s'active qu'au-delà de 10 px (4 px à la souris). */
export const LONG_PRESS_MS = 500;
export const TOUCH_SLOP_PX = 10;
export const MOUSE_SLOP_PX = 4;

type Point = { x: number; y: number };

/** Appui long armé sur un endroit vide de la carte : il se déclenche au bout de `LONG_PRESS_MS` si le doigt reste à
 *  moins de `TOUCH_SLOP_PX` de son point de départ ; un mouvement plus grand, un second doigt, le doigt levé ou la
 *  carte qui se déplace l'annulent (`cancel`), pour ne jamais gêner le déplacement ni le pincement de la carte. */
export interface LongPress {
  /** Arme l'appui (`touches` : doigts posés ; plus d'un : rien n'est armé, l'appui en cours est annulé). */
  start(point: Point, touches: number, fire: () => void): void;
  /** Doigt déplacé : au-delà du seuil (ou un second doigt arrivé), l'appui est annulé. */
  move(point: Point, touches?: number): void;
  cancel(): void;
  readonly pending: boolean;
}

export function createLongPress(delay = LONG_PRESS_MS, slop = TOUCH_SLOP_PX): LongPress {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let origin: Point | null = null;
  const cancel = () => {
    if (timer !== null) clearTimeout(timer);
    timer = null;
    origin = null;
  };
  return {
    start(point, touches, fire) {
      cancel();
      if (touches > 1) return;
      origin = point;
      timer = setTimeout(() => {
        timer = null;
        origin = null;
        fire();
      }, delay);
    },
    move(point, touches = 1) {
      if (!origin) return;
      if (touches > 1 || Math.hypot(point.x - origin.x, point.y - origin.y) >= slop) cancel();
    },
    cancel,
    get pending() {
      return timer !== null;
    },
  };
}
